// Inline so it paints with tokens; public/favicon.svg is its hex copy, as a favicon reads no CSS.
export function Mark({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <rect width="72" height="72" rx="16" fill="var(--ink)" />
      <path d="M20 12h14a24 24 0 0 1 0 48H20z" fill="var(--bg)" />
      <path
        d="M9 63L63 9"
        stroke="var(--action)"
        strokeWidth="15"
        strokeLinecap="round"
        opacity=".22"
      />
      <path d="M9 63L63 9" stroke="var(--action)" strokeWidth="7" strokeLinecap="round" />
    </svg>
  );
}
